import spinner from "../../assets/spinner.svg";

export default function Spinner() {
  return (
    <div className="flex items-center w-28 h-7 mt-2 rounded-md">
      <img src={spinner} alt="" height={30} width={30} />
    </div>
  );
}
